// DEPENDENCIES
import React from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import SVG from "react-inlinesvg";
import { Link } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
// CUSTOM COMPONENTS
// STYLE SCRIPTS
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import * as confirmModal from "../../redux/confirmModalRedux";
import * as alert from "../../redux/alertSnackBarRedux";
import * as formService from "../../services/form/formService";

const FormCard = (props) => {
    const { form, showConfirmModal, hideConfirmModal, setProcessing, showAlert, refreshForms, updateFormIdToEdit, updateEditModalOpen } = props;
    const { name, badgeColor, formType, description, fileExtension } = form;

    const badgeMapper = {
        'BUILT-IN': 'bg-success',
        'UPLOAD': 'bg-info',
        'CUSTOM': 'bg-warning'
    }

    const svgImageMapper = {
        '.xls': 'csv',
        '.xlsx': 'csv',
        '.csv': 'csv',
        '.doc': 'doc',
        '.docx': 'doc',
        '.pdf': 'pdf',
        '.jpg': 'jpg',
        '.png': 'jpg',
        '.jpeg': 'jpg',
        'BUILT-IN': 'builtIn',
        'CUSTOM': 'custom'
    }

    const deleteForm = (formId) => {
        setProcessing(true);
        formService.deleteForm(formId).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            refreshForms();
            hideConfirmModal();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        });
    }

    const editForm = (formId) => {
        updateFormIdToEdit(formId);
        updateEditModalOpen(true);
    }

    return (
        <>
            <div className="form-card-container mb-20">
                <div className="form-card-header">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>{name}</Tooltip>
                        }
                    >
                        <p>
                            {name}
                        </p>
                    </OverlayTrigger>
                    <div className={`form-card-badge ${badgeColor}`}>
                        <span className={`small-badge ${badgeMapper[formType]}`}>
                            {formType}
                        </span>
                    </div>
                </div>
                <div className="form-card-body">
                    <div className="form-card-image-container">
                        {formType === "UPLOAD" && <div className="form-card-delete-action" onClick={() => showConfirmModal({
                            title: "Delete Form",
                            text: "Are you sure you want to delete the form: <strong>" + name + "</strong>?",
                            rightBtnText: "Confirm",
                            btnAction: () => deleteForm(form.id)
                        })}>
                            <a>
                                <IoClose color="white" />
                            </a>
                        </div>}
                        <SVG
                            className="h-50 align-self-center"
                            src={toAbsoluteUrl(`/media/svg/files/${svgImageMapper[fileExtension]}.svg`)}
                        >
                        </SVG>
                    </div>
                    <div className="form-card-details">
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip>{description}</Tooltip>
                            }
                        >
                            <p>
                                {description ? (description.substring(0, 147) + ((description.length > 147) ? '...' : '')) : ''}
                            </p>
                        </OverlayTrigger>
                    </div>
                    <div className="form-card-actions">
                        {formType === "UPLOAD" && <button onClick={() => editForm(form.id)} className="btn btn-info btn-block">
                            Edit Form
                        </button>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(null, { ...confirmModal.actions, ...alert.actions })(FormCard);